module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Fire-38176a3de2614554b40af5a9d23494ab.svg";